import { request } from './request'

//积分商城列表
export function getGifts(page) {
  return request({
    url: '/gifts',
    method: "get",
    params: {
      page
    }
  })
}
//礼品详情
export function getGiftDetail(gift_id) {
  return request({
    url: '/gifts' + '/' + gift_id,
    method: "get",
    params: {
      gift_id
    }
  })
}
//兑换礼品
export function redeemedGifts(data) {
  return request({
    url: '/redeemed_gifts',
    method: "post",
    data
  })
}